import React, { useEffect } from "react";

import "../css/Page__Styles.css";
import "../css/Page__Services.css";

import Footer from "../components/Footer.jsx";

import PackagingImage from "../img/services-packaging.png";
import WebImage from "../img/services-web.png";
import EditorialImage from "../img/services-editorial.png"
import BrandingImage from "../img/services-branding.png"


export const ProjectDirectory = () => {

  useEffect(() => {
    document.title = "Eme / Servicios";
  }, []);


  return (
    <div className="project_directory_page">

      <section className="page_service_directory">

        <h2>
          Estrategia, diseño y una mirada centrada en las personas para
          crear marcas que conectan, importan y perduran, sin límites.
        </h2>


        <div className="services_grid">

          <div className="service_card">

            <div className="service_card_image">
              <img src={BrandingImage} alt="" />
            </div>

            <div className="service_card_content">
              <h3>Branding</h3>

              <p>
                A través de la escucha, el análisis y una mirada estratégica,
                se descubre la esencia de cada marca para convertirla en una
                identidad con propósito y dirección.
              </p>
            </div>

          </div>


          <div className="service_card">

            <div className="service_card_image">
              <img src={WebImage} alt="" />
            </div>

            <div className="service_card_content">
              <h3>Web</h3>

              <p>
                Desde las necesidades de las personas diseño experiencias
                digitales claras, intuitivas y conectadas con cada marca.
              </p>
            </div>

          </div>


          <div className="service_card">

            <div className="service_card_image">
              <img src={PackagingImage} alt="" />
            </div>

            <div className="service_card_content">
              <h3>Packaging</h3>

              <p>
                La identidad de la marca se extiende al producto
                para formar parte de su recorrido y reforzar
                su presencia en cada punto de contacto.
              </p>
            </div>

          </div>


          <div className="service_card">

            <div className="service_card_image">
              <img src={EditorialImage} alt="" />
            </div>

            <div className="service_card_content">
              <h3>Editorial</h3>

              <p>
                El trabajo editorial combina contenido, diseño y narrativa para
                dar forma a publicaciones que informan, conectan y generan
                una experiencia cuidada.
              </p>
            </div>

          </div>

        </div>

      </section>


      <Footer />

    </div>
  );
};


export default ProjectDirectory;